import { NgModule } from '@angular/core';

import { ImpressumRoutingModule } from './impressum-routing.module';
import { ImpressumComponent } from './impressum.component';

@NgModule({
    declarations: [
        ImpressumComponent
    ],
    imports: [
        ImpressumRoutingModule
    ],
    exports: [
        ImpressumComponent
    ]
})
export class ImpressumModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/app/impressum/impressum.module.ts